import axios from "axios"
const authService = {
    login: (endPoint, data) => {
        return axios.post(process.env.REACT_APP_BASE_URL + endPoint, data)
            .then((response) => {
                return response; // If the request is successful, return the response
            })
            .catch((error) => {
                throw error; // If the request fails, throw the error
            });

    }
}

export default authService;